import { Directive } from '@angular/core';

@Directive({ selector: 'ng-template[appUiTabLabel]' })
export class UiTabLabelDirective {}
